import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { useAdRecruitStore } from 'src/stores/AdRecruitStore';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
        paddingTop: 0,
        paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'center',
    justifyContent:'center',
    border: '1px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    // '& svg': {
    //   right: '30%',
    //   transform: 'translateX(50%)',
    //   position: 'absolute',
    //   pointerEvents: 'none',
    // },
}

const DropBoxSx = {
    // justifyContent: 'center',
    // textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

const AdRecruitSelectType = () => {
    const typeContent = ['전체','부사관','장교','준사관']
    const type = useAdRecruitStore((state)=>state.type)
    const setField = useAdRecruitStore((state)=>state.setField)
    const handleTypeChange = (e:SelectChangeEvent<string>)=>{
      const value = e.target.value;
      setField('page',1)
      setField('type', value === '전체' ? '' : value);
    }

  return (
      <Select
          displayEmpty
          value={type}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}` || '모집유형' }
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content) => (
              <MenuItem value={content.toString()} sx={DropBoxSx}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default AdRecruitSelectType